import { Outlet } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";
import { ivrDetailQueryOptions } from "@/server/ivr";
import { dehydrate, HydrationBoundary } from "@tanstack/react-query";

export const Route = createFileRoute("/_dashboard/ivr/$ivrId")({
  component: RouteComponent,
  loader: async ({ params, context }) => {
    const queryOptions = ivrDetailQueryOptions(params.ivrId);
    //We need to prefetch the query in order to get the name for the breadcrumb
    await context.queryClient.prefetchQuery(queryOptions);
    const ivr = context.queryClient.getQueryData(queryOptions.queryKey) as { name?: string } | undefined;

    return {
      ivrId: params.ivrId,
      crumb: ivr?.name,
      dehydratedState: dehydrate(context.queryClient) as any,
    };
  },
});

function RouteComponent() {
  const { dehydratedState } = Route.useLoaderData();
  return (
    <HydrationBoundary state={dehydratedState}>
      <Outlet />
    </HydrationBoundary>
  );
}
